import ApiClient from '@platform/plugins/AxiosPlugin'
import { CMP_LOADED } from '../dow-platform/components/core/ACDLHandler'
import {
    getParameter,
    getURLParameter,
    documentViewerRedirect,
    getDocumentURLParameter,
    getSafeRedirectURL
} from '../utils/url'
import { hsession_interval } from '../utils/index'
import { refresh_sessions_interval } from '../utils/index'
import { getCookiebyName } from '../utils/cookies'
import { clearChatbotState } from '../dow-platform/components/ui/chatbot/chatbot-history'

const TRACK_LOGIN = 'user:login'
const AMCV_ID = 'AMCV_988D095F54BD18520A4C98A5%40AdobeOrg'
const userCookie =
    document.cookie
        .split('; ')
        .find((row) => row.startsWith('uuid'))
        ?.split('=')[1] || null

const hasTimedOut = sessionStorage.getItem('hasTimedOut') === '1'

export default {
    namespaced: true,
    state: {
        dccUserInfo: {},
        anonSampleCartCount: 0,
        showAddToCartBubble: false,
        addToCartBubbleText: '',
        showAddToCartBubbleIssue: false,
        hasTimedOut: hasTimedOut,
        isAuthenticated: !!userCookie && !hasTimedOut,
        authErrors: [],
        termsAccepted: true,
        reauthorizationRequired: false,
        reloadRequired: true,
        username: '',
        loading: false,
        redirecting: false,
        guestEmail: null,
        privacy: [],
        isReloading: false,
        isVerificationError: false,
        reauthPostponed: localStorage.getItem('reauthPostponed'),
        userInfoFetched: false,
        reauthorizationRequiredAfterLogin: false,
        ecid: null,
        advancedAccountTypes: [
            "buyer",
            "accountbalanceinvoices",
            "deliverytracking",
            "invoicetracking",
            "ordertracking",
            "viewcatalog",
            "viewdistributorsrp",
            "viewpricingavailability",
            "viewallcases",
            "viewcontracts",
            "viewdeliveryvisibility",
            "multipopreview"
        ]
    },
    getters: {
        acceptedPerformanceCookies: (state) =>
            isPrivacyCategoryAccepted(state, 'C0002'),
        acceptedFunctionalCookies: (state) =>
            isPrivacyCategoryAccepted(state, 'C0003'),
        acceptedTargetingCookies: (state) =>
            isPrivacyCategoryAccepted(state, 'C0004'),
        acceptedSocialCookies: (state) =>
            isPrivacyCategoryAccepted(state, 'C0005'),
        isBasic: state => !!state.dccUserInfo.data?.roles
            ?.filter(({ uid }) => uid == 'basicuser').length,
        isGenAIEnabled: state => !!state.dccUserInfo.data?.roles
            ?.filter(({ uid }) => uid === 'search-gen-ai').length
    },
    mutations: {
        dccUserInfo: setDccUserInfo,
        authErrors: setAuthErrors,
        showAddToCartBubble: setShowAddToCartBubble,
        setAddToCartBubbleText,
        showAddToCartBubbleIssue: setShowAddToCartBubbleIssue,
        termsAccepted: setTermsAccepted,
        isAuthenticated: setIsAuthenticated,
        guestEmail: setGuestEmail,
        reauthorizationRequired: setReauthorizationRequired,
        loading: setLoading,
        redirecting: setRedirecting,
        privacy: setPrivacyPreferences,
        isVerificationError: setIsVerificationError,
        reauthPostponed: setReauthPostponed,
        reloadRequired: setReloadRequired,
        setSampleCartCount,
        setAnonSampleCartCount,
        setECID
    },
    actions: {
        updateDccUserInfo,
        updateSampleCartCount,
        isLoggedIn,
        sessionTimedOut,
        loginCIAMUser,
        redirectCIAMUser,
        logoutUser,
        logoutCIAMUserForReauth,
        trackLogin,
        updateGuestEmail,
        loginRedirect,
        updatePrivacyPreferences,
        updateECID,
        reloadPage,
        [TRACK_LOGIN]: { root: true, handler() {} },
        [CMP_LOADED]: {
            root: true,
            handler({ dispatch }) {
                const queryString = window.location.search
                const urlParams = new URLSearchParams(queryString)
                let appId
                //read query param for application
                if (urlParams) {
                    appId = urlParams.get('a')
                }
                dispatch('isLoggedIn')
            }
        }
    }
}

function updatePrivacyPreferences({ state, commit, getters }, preferences) {
    commit('privacy', preferences)

    return state.privacy
}

function isPrivacyCategoryAccepted(state, category) {
    return state.privacy.includes(category)
}

function setPrivacyPreferences(state, categories) {
    if (typeof categories == 'string')
        categories = categories
            .split(',')
            .filter((category) => Boolean(category))
    if (categories instanceof Array) state.privacy = categories
}

async function logoutUser(context) {
    var locale = this.state.browser.cookies['languageCode'] || 'en-us'
    try {
        const response = await ApiClient.post(
            context.rootState.settings.logout_servlet,
            new FormData(),
            {
                headers: {
                    'Content-Type':
                        'application/x-www-form-urlencoded; charset=UTF-8'
                }
            }
        )
        setLoggedInStatusClass(false)

        if (sessionStorage.getItem('fetchedWebsiteUpdate')) {
            sessionStorage.removeItem('fetchedWebsiteUpdate')
        }

        if (localStorage.getItem('showUpdatesBanner')) {
            localStorage.removeItem('showUpdatesBanner')
        }

        context.commit('isAuthenticated', false)

        if (context.state.reauthorizationRequired)
            context.commit('reauthorizationRequired', false)

        context.commit('reauthPostponed', 'false')
        clearChatbotState()
        localStorage.setItem('logout', 'true')
        if (localStorage.getItem('dowComCoveoToken'))
            localStorage.removeItem('dowComCoveoToken')
        if (localStorage.getItem('lastRefreshAccessTime')) {
            localStorage.removeItem('lastRefreshAccessTime')
        }
        store.dispatch('browser/setLocation', {}).then(() => {

            if (sessionStorage.getItem('hasTimedOut') === '1') {
                location.href =
                    '/' +
                    locale +
                    context.rootState.settings.LOGIN_PAGE +
                    '?redirectUrl=' +
                    encodeURIComponent(location.pathname + location.search + getAnchorFromURL(window.location.href))
            } else location.href = '/' + locale + '.html'
            
        })
    } catch (err) {
        context.commit('authErrors', err.response)
        return Promise.reject(err)
    }
}

async function logoutCIAMUserForReauth(context) {
    var locale = this.state.browser.cookies['languageCode'] || 'en-us'
    try {
        const response = await ApiClient.post(
            context.rootState.settings.logout_servlet,
            new FormData(),
            {
                headers: {
                    'Content-Type':
                        'application/x-www-form-urlencoded; charset=UTF-8'
                }
            }
        )
        setLoggedInStatusClass(false)

        if (sessionStorage.getItem('fetchedWebsiteUpdate')) {
            sessionStorage.removeItem('fetchedWebsiteUpdate')
        }

        if (localStorage.getItem('showUpdatesBanner')) {
            localStorage.removeItem('showUpdatesBanner')
        }

        context.commit('isAuthenticated', false)

        if (context.state.reauthorizationRequired)
            context.commit('reauthorizationRequired', false)

        context.commit('reauthPostponed', 'false')
        clearChatbotState()
        localStorage.setItem('logout', 'true')
        if (localStorage.getItem('dowComCoveoToken'))
            localStorage.removeItem('dowComCoveoToken')
        if (localStorage.getItem('lastRefreshAccessTime')) {
            localStorage.removeItem('lastRefreshAccessTime')
        }
    } catch (err) {
        context.commit('authErrors', err.response)
        return Promise.reject(err)
    }
}

function setDccUserInfo(state, dccUserInfo) {
    state.dccUserInfo = dccUserInfo
}

async function updateDccUserInfo(context, dccUserInfo) {
    let isLogout = localStorage.getItem('logout') === 'false';
    context.dispatch('updateECID');
    if (
        !dccUserInfo ||
        !Object.getOwnPropertyNames(dccUserInfo).filter(
            (prop) => prop != '__ob__'
        ).length
    ) {
        if (dccUserInfo === true && isLogout) {
            const userInfoUrl = `/.dow.dcc.user.info.json`
            try {
                context.state.userInfoFetched = ApiClient.get(userInfoUrl)
                const data = await context.state.userInfoFetched
                context.commit('dccUserInfo', data)
                let isLoggedIn = context.state.dccUserInfo?.data?.email
                    ? true
                    : false
                if(isLoggedIn) {
                    context.dispatch('updateSampleCartCount')
                } else {
                    var sampleCartCount = 0;
                    if(localStorage.getItem('sampleCart')){
                        var sampleJson = JSON.parse(localStorage.getItem('sampleCart'))
                        sampleCartCount = sampleJson?.sampleCartCount || 0
                    }
                    context.commit('setAnonSampleCartCount', sampleCartCount || 0)
                }
                let reauthRequired = context.state.dccUserInfo?.data
                    ?.reauthorizationRequired
                    ? context.state.dccUserInfo?.data?.reauthorizationRequired
                    : false
                context.commit('isAuthenticated', isLoggedIn)
                context.commit('reauthorizationRequired', reauthRequired)
                setLoggedInStatusClass(isLoggedIn)
                setCanShowTruckStatusClass(
                    context.state.dccUserInfo.data?.canShowTruck
                )
                sessionStorage.setItem(
                    'cartGuid',
                    context.state.dccUserInfo?.data?.cartGuid
                )
                if (isLoggedIn) {
                    context.dispatch(
                        'browser/inactivityLogout',
                        {},
                        { root: true }
                    )
                    window.isSessionManagementEnabled
                        ? refresh_sessions_interval()
                        : hsession_interval()
                }
                return isLoggedIn
            } catch (error) {
                console.log('Failed to load users data.')
            }
        } else {
            return context.state.userInfoFetched
        }

    } else {
        context.commit('dccUserInfo', dccUserInfo)
        let isLoggedIn = context.state.dccUserInfo.data?.email ? true : false
        context.commit('isAuthenticated', isLoggedIn)
        setLoggedInStatusClass(isLoggedIn)
        setCanShowTruckStatusClass(context.state.dccUserInfo.data?.canShowTruck)
        return Promise.resolve(isLoggedIn)
    }
}

function sessionTimedOut(context) {
    sessionStorage.setItem('hasTimedOut', '1')
    context.state.hasTimedOut = '1'
    clearChatbotState()
}

function isLoggedIn(context) {
    if (context.state.dccUserInfo?.data?.email) {
        return Promise.resolve(true)
    } else if (!context.state.dccUserInfo.data) {
        return context.dispatch('updateDccUserInfo')
    } else {
        return Promise.resolve(false)
    }
}

function setLoggedInStatusClass(isLoggedIn) {
    if (isLoggedIn) {
        document.body.classList.add('is-logged-in')
    } else {
        if (document.body.classList.contains('is-logged-in')) {
            document.body.classList.remove('is-logged-in')
        }
    }
}

function setCanShowTruckStatusClass(canShowTruck) {
    if (canShowTruck) {
        document.body.classList.add('can-show-truck')
    } else {
        if (document.body.classList.contains('can-show-truck')) {
            document.body.classList.remove('can-show-truck')
        }
    }
}

function setAuthErrors(context, payload) {
    if (payload?.data?.error_type !== 'TERMS_NOTACCEPTED') {
        if (payload?.data?.error_type === 'login.failed.Title') {
            payload.data.error_type =
                window.Granite.I18n.get('login.failed.Title')
            payload.data.message = window.Granite.I18n.get(
                'login.error.exception.message'
            )
        }

        context.authErrors.push(payload)
    } else {
        context.termsAccepted = false
        if (payload?.data?.username) {
            let userNameCamel = payload?.data?.username?.toLowerCase()
            userNameCamel = userNameCamel.replace(/\b\w+\b/g, function (word) {
                return word.substring(0, 1).toUpperCase() + word.substring(1)
            })
            context.username = userNameCamel
        } else {
            context.username = payload?.data?.userid
        }
    }
}

function setTermsAccepted(context, payload) {
    context.termsAccepted = payload
}

function setShowAddToCartBubble(context, payload) {
    context.showAddToCartBubble = payload
}

function setAddToCartBubbleText(context, payload) {
    context.addToCartBubbleText = payload
}

function setShowAddToCartBubbleIssue(context, payload) {
    context.showAddToCartBubbleIssue = payload
}

function setIsAuthenticated(context, payload) {
    context.isAuthenticated = payload
}

function setGuestEmail(context, payload) {
    context.guestEmail = payload
}

function updateGuestEmail(context, payload) {
    context.commit('guestEmail', payload)
}

function setReauthorizationRequired(context, payload) {
    context.reauthorizationRequired = payload
}

function setLoading(context, payload) {
    context.loading = payload
}

function setRedirecting(context, payload) {
    context.redirecting = payload
}

function setIsVerificationError(context, payload) {
    context.isVerificationError = payload
}

function setReauthPostponed(context, payload) {
    context.reauthPostponed = payload
    localStorage.setItem('reauthPostponed', payload.toString())
}

function setReloadRequired(context, payload) {
    context.reloadRequired = payload
}

function setECID(context, payload){
    context.ecid = payload
}

function trackLogin(context, data) {
    var userObj = context.state.dccUserInfo.data
    var ldapGuid = data?.LDAP_GUID || userObj?.ldapGuid || 'Undefined'
    var shipToId =
        data?.selectedShipTo || userObj?.selectedShipToId || 'Undefined'
    var soldToId =
        data?.selectedSoldTo || userObj?.selectedSoldToId || 'Undefined'
    var companyName = data?.defaultDeliveryAddress?.companyName || 'Undefined'
    const isBasicUser = !!data?.isBasic

    window.adobeDataLayer.push({
        event: 'user:login',
        user: {
            webAccountID: ldapGuid,
            webAccountDomain: data?.isInternal ? 'dow' : 'external',
            shipTo: isBasicUser ? 'Basic User' : `${shipToId}|${companyName}`,
            soldTo: isBasicUser ? 'Basic User' : `${soldToId}|${companyName}`,
            companyName: data?.companyName || 'Undefined'
        }
    })

    return new Promise((resolve) => setTimeout(resolve, 1000));
}


function getAnchorFromURL(url) {
    var Anchors = url.split('#');
    if (Anchors.length > 1) {
        return "#" + Anchors[1];
    } else {
        return "";
    }
}

function getLanguageCode(context){
    var languageCode = context.rootState.browser.cookies['languageCode']
    if (languageCode == null){
        languageCode = location.pathname.slice(1, 6)
    } 
    languageCode = languageCode.toLowerCase()
    return languageCode || 'en-us'
}

async function loginRedirect(context, payload) {
    context.commit('loading', true)
    while (!context.state.dccUserInfo?.data?.email) {
        await new Promise(resolve => setTimeout(resolve, 100));
    }

    let approvedDomains = context.rootState.settings.LOGIN_REDIRECT_DOMAINS
    let defaultFallback = window.location.origin + window.location.pathname.replace(
        context.rootState.settings.LOGIN_PAGE,
        context.rootState.settings.DEFAULT_REDIRECT_URL
    )

    var timeOutPageUrl = context.rootState.browser.cookies['timeOutPage']
    if (
        typeof timeOutPageUrl !== 'undefined' &&
        timeOutPageUrl !== null &&
        timeOutPageUrl !== ''
    ) {
        context.dispatch('browser/removeBrowserCookie', 'timeOutPage')
        $('.dcc_timeout_notification').addClass('hidden')
        window.location.href = getSafeRedirectURL(timeOutPageUrl, approvedDomains, window.location.origin)
        return
    }

    //Sample Request Login
    var isSampleRequest = $('#isSampleRequest').val()
    if (isSampleRequest === 'isSampleRequest') {
        $('.loginFormModal .sample-request-user-exits').addClass('hidden')
        window.history.back()
        return
    }

    //login page flag
    var isFromLoginPage = false
    var urlSearch = window.location.search ? window.location.search : ''
    var urlObj = getURLParameter(urlSearch)
    //extract redirect URL from main URL
    var redirectUrl = urlSearch.indexOf('document-viewer.html') > -1 ? getDocumentURLParameter(urlObj) : urlObj.get('redirectUrl')

    if (window.location.href.indexOf('login.html') !== -1 || window.location.href.indexOf('simple-registration.html') !== -1) {
        isFromLoginPage = true
        if (
            redirectUrl &&
            urlSearch.indexOf('document-viewer.html') > -1 &&
            urlSearch.indexOf('redirectUrl') > -1
        ) {
            documentViewerRedirect(redirectUrl, approvedDomains)
        } else {
            redirectUrl = (redirectUrl || '') + getAnchorFromURL(window.location.href)

            let safeURL = getSafeRedirectURL(redirectUrl, approvedDomains, defaultFallback)
            let hasValidRedirect = redirectUrl && redirectUrl !== 'null' && safeURL !== defaultFallback

            if (hasValidRedirect) {
                context.commit('redirecting', true)
                window.location.href = safeURL
            } else {
                var interestParam = getParameter('interest')
                var fromRegistration = getParameter('fromRegistration')
                var elqCookie = getCookiebyName("elqQueryString")
                var elqCookieExists = elqCookie != null && elqCookie != '';
                var interestParamExists = interestParam != null && interestParam != '';
                if (interestParamExists || (elqCookieExists && fromRegistration === 'true')) {
                    var formattedInterestArray = []
                    if(interestParamExists){
                        var interestArray = interestParam.split(',')
                        $.each(interestArray, function (i, val) {
                            if (val.indexOf('/') > -1) {
                                var splitInterest = val.split('/')
                                formattedInterestArray.push(
                                    splitInterest[splitInterest.length - 1]
                                )
                            } else {
                                formattedInterestArray.push(val)
                            }
                        })
                    }

                    updateInterests(context, formattedInterestArray)
                } else {
                    context.commit('redirecting', true)
                    window.location.href = defaultFallback
                }
            }
        }
    }

    //if not from login page and isReload element exists, reload page
    if (!isFromLoginPage) {
        context.state.isReloading = true
        let currentUrl =  window.location.href
        let stringsToCheck = ['pdp', 'crop-solver', 'search', 'sample-cart']; 
        let shouldNotRedirect = stringsToCheck.some(str => currentUrl.includes(str));
        
        if(!shouldNotRedirect){
            context.commit('redirecting', true)
            window.location.href="/"+ getLanguageCode(context)+"/my-account.html"
        }else{
            location.reload()
        }
    }

    if ($('#simpleRegConfirmId').text() != '') {
        var languageCode = getLanguageCode(context)
        var locale =
            context.rootState.settings.LANGUAGE_ARRAY.indexOf(languageCode) > -1
                ? languageCode
                : 'en-us'
        var urlSearch = window.location.search ? window.location.search : ''
        if (urlSearch.indexOf('redirectUrl') > -1) {
            var urlObj = getURLParameter(urlSearch)
            var redirectUrl = decodeURIComponent(urlObj.get('redirectUrl'))

            if (
                !redirectUrl.startsWith('http') &&
                !redirectUrl.startsWith('/') &&
                redirectUrl.indexOf(context.rootState.settings.URL_BASE) !== 0
            ) {
                redirectUrl = context.rootState.settings.URL_BASE + redirectUrl
            }

            documentViewerRedirect(redirectUrl, approvedDomains)
        } else {
            window.location.href = '/' + locale + '.html'
        }
    }
    context.commit('loading', false)
}

function updateInterests(context, interests) {
    const formdata = new FormData()
    formdata.append('industry', interests)
    ApiClient.post(context.rootState.settings.interest_update, formdata, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        }
    })
        .then(function (response) {
            if(interests != null && interests.length > 0){
                const cleanUrl = window.location.origin + window.location.pathname.replace(
                    context.rootState.settings.LOGIN_PAGE,
                    context.rootState.settings.DEFAULT_REDIRECT_URL +
                        '#my-preferences'
                )
                window.location.href = cleanUrl
            }
            else{
                const cleanUrl = window.location.origin + window.location.pathname.replace(
                    context.rootState.settings.LOGIN_PAGE,
                    context.rootState.settings.DEFAULT_REDIRECT_URL
                )
                window.location.href = cleanUrl
            }
        })
        .catch(function (error) {
            console.log('Error updating interests', error)
        })
}

function reloadPage(context) {
    context.state.isReloading = true
    window.location.reload()
}

function updateSampleCartCount(context) {
    var _this = this
    var sampleGuid = null
    if(localStorage.getItem('sampleCart')){
        var sampleData = JSON.parse(localStorage.getItem('sampleCart'))
        sampleGuid = sampleData?.sampleCartGuid
    }
    if (
        sessionStorage.getItem('fetchedSampleCount') != 'true' ||
        (sampleGuid && sampleGuid != 'undefined')
    ) {
        sessionStorage.setItem('fetchedSampleCount', true)
        ApiClient.get(context.rootState.settings.sample_cart_count_servlet, {
            params: { sampleGuid: sampleGuid }
        })
            .then(function (response) {
                let isAuthenticated = store.state.user.isAuthenticated
                if(isAuthenticated) {
                    context.commit('setSampleCartCount', response.data)
                    localStorage.removeItem("sampleCart")
                    context.commit('setAnonSampleCartCount', 0)
                } else {
                    context.commit('setAnonSampleCartCount', response.data)
                }
            })
            .catch(function (error) {
                sessionStorage.setItem('fetchedSampleCount', null)
                console.log(error)
            })
    }
}
function setSampleCartCount(state, payload) {
    state.dccUserInfo.data.numberOfSampleCartItems = payload
}

function setAnonSampleCartCount(state, payload) {
    state.anonSampleCartCount = payload
}

function updateECID(context, payload){
    let amcvCookie = this.state.browser.cookies[AMCV_ID] 
    let ECID = amcvCookie?.split("|")[1] || null;
    context.commit('setECID', ECID);
}

async function redirectCIAMUser(context, payload) {
    context.commit('loading', true)
    const languageCode = getLanguageCode(context);
    const noPayload =
        payload == "" ||
        payload == undefined ||
        payload == "/" ||
        payload == "/" + languageCode + ".html";

    let gotoUrl = ""

    if(!noPayload) {
        gotoUrl = encodeURIComponent(payload)
    }

    const servletUrl = new URL(window.location.origin + context.rootState.settings.oidc_login_initiation_servlet)
    servletUrl.searchParams.set('goto', gotoUrl)
    context.commit('loading', false)
    window.location.href = servletUrl.toString()
}

async function loginCIAMUser(context, payload) {
    if (sessionStorage.getItem('hasTimedOut') === '1') {
        sessionStorage.setItem('hasTimedOut', '0')
    }

    localStorage.setItem('logout', 'false')
    clearChatbotState()

    if (localStorage.getItem('reauthPostponed') === 'true') {
        localStorage.setItem('reauthPostponed', 'false')
    }
    const locale = this.state.browser.cookies['languageCode'] || 'en-us'
    context.commit('loading', true)
    try {
            const formdata = new URLSearchParams()
            if(payload.code) {
                formdata.append('code', payload.code)
            }
            if(payload.state) {
                formdata.append('state', payload.state)
            }
            if(payload.redirectUrl) {
                formdata.append('redirectUrl', payload.redirectUrl)
            }
            
            const response = await ApiClient.post('/.dow.oidc.authenticate.json', formdata)
            console.log('Response ', response)
            context.commit('dccUserInfo', response)
            context.commit('isAuthenticated', response.data?.email ? true : false)
            context.commit('reauthorizationRequired', response.data?.reauthorizationRequired ? response.data.reauthorizationRequired : false)

        if(localStorage.getItem('dowComCoveoToken'))
            localStorage.removeItem('dowComCoveoToken')

        if (response.data.reauthorizationRequired === 'true') {
               context.commit('reauthorizationRequired', true)
               context.state.reauthorizationRequiredAfterLogin = true
               context.dispatch('loginRedirect', response)
       } else {
            console.log('Redirecturl: ', response.data.redirectUrl)
            let redirectUrl = response.data?.redirectUrl
            if (redirectUrl) {
                const redirectUrlObj = new URL(decodeURIComponent(redirectUrl))
                const url = new URL(window.location.href)
                const redirectParameter = redirectUrlObj.searchParams.get('redirectUrl')
                if (redirectParameter) {
                    url.searchParams.set('redirectUrl', redirectParameter)
                }
                const fromRegistration = redirectUrlObj.searchParams.get('fromRegistration')
                if(fromRegistration){
                    url.searchParams.set('fromRegistration', fromRegistration)
                }
                const interestParameter = redirectUrlObj.searchParams.get('interest')
                if(interestParameter){
                    url.searchParams.set('interest', interestParameter)
                }
                history.replaceState({}, '', url.toString())
            }
            //Validate url
            context.dispatch('loginRedirect', response)
        }

        await context.dispatch('updateDccUserInfo', true)
        await context.dispatch('trackLogin', response.data)

        context.commit('loading', false)
    } catch (err) {
        const errorResponse = err.response ?? {
            data: {
                error_type: 'login.failed.Title',
                message: null
            }
        }
        context.commit('authErrors', errorResponse)
        context.commit('loading', false)
        return Promise.reject(err)
    }
}